define(['jquery', 'globalVars', 'mage/translate', 'matchSize'], function (
    $,
    { $window },
    $t,
    matchSize
) {
    return {
        options: {
            selectors: {
                pageSwitcher: '[data-role=page-switcher]',
                switcher: '[data-role=switch-button]',
                labels: '[data-role=label]',
                profshopLabel: '[data-profshop-label]',
            },

            classes: {
                buttonDisplaySalons: 'page-switcher__button_display-salons',
                buttonDisplayProfessionShops:
                    'page-switcher__button_display-profession-shops',
                labelActive: 'page-switcher__label_active',
            },
        },

        init() {
            this.initCache();
            this.initEvents();
        },

        initCache() {
            this.$switcher = $(this.options.selectors.switcher);
            this.$labels = $(this.options.selectors.labels);
            this.$profshopLabel = $(this.options.selectors.profshopLabel);
        },

        initEvents() {
            $(this.options.selectors.pageSwitcher).on(
                'click',
                this.onPageSwitcherClick.bind(this)
            );
        },

        onPageSwitcherClick() {
            this.$switcher.toggleClass(
                this.options.classes.buttonDisplayProfessionShops
            );
            this.$switcher.toggleClass(
                this.options.classes.buttonDisplaySalons
            );
            this.$labels.toggleClass(this.options.classes.labelActive);

            const origin = window.location.origin;
            const switchingPathname =
                window.location.pathname === '/salon-locator/search'
                    ? '/profshop-locator'
                    : '/salon-locator/search';
            const parametersThisPage = window.location.search;

            window.location.href = `${origin}${switchingPathname}${parametersThisPage}`;
        },
    };
});
